import {ApiModel} from './api-model';
import {UserProfile} from './user-profile';

export class Privilege extends ApiModel {
  component: number;
  action: number;
  checked: boolean;
  checkedByExtends: boolean;
  checkedByLogic: boolean;

  checkedByProfiles(profiles: UserProfile[]) {
    this.checked = false;
    this.checkedByExtends = false;
    profiles.forEach(profile => {
      if (profile.hasPrivilege(this)) {
        this.checked = true;
        this.checkedByExtends = true;
        this.checkedByLogic = false;
      }
    });
    return this;
  }

  checkedByInputPrivileges(privileges: Privilege[]) {
    if (!!privileges.find((privilege) => privilege.action === this.action && privilege.component === this.component)) {
      this.checked = true;
      // this.checkedByExtends = false;
    }
    return this;
  }

  checkedByLogicPrivileges(privileges: Privilege[], privilegesState: Privilege[]) {
    this.checkedByLogic = false;
    if (this.action === 1) {
      if (privilegesState.find(p => p.checked && p.action === 2 && p.component === this.component)) {
        this.checked = true;
        this.checkedByLogic = true;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/privilege.ts